import React from "react";
import { useSelector } from 'react-redux';
import Slider from "react-slick";
import Card from "./card/Card";
import {useHistory} from 'react-router-dom';
const settings = {
  dots: false,
  infinite: true,
  easing: "ease-in-out",
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  swipeToSlide: true,
  centerPadding: '0',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const BestSelling = () => {
  const { items } = useSelector(state => state.bestSelling);
  const history = useHistory();
  const nav=()=>{
    history.push('detail-produk')
    window.scrollTo(0, 0)
    
  }
  return (
    <div className="best-selling container">
      <div className="container">
        <div className="best-selling-head">
          <h3>Produk Terlaris</h3>
          <p>Lihat Semua</p>
        </div>
        <Slider {...settings}>
          {items.map((product) => (
            <Card
              onClick={nav}
              key={product.id}
              img={product.img}
              alt={product.alt}
              productName={product.productName}
              qty={product.qty}
              discount={product.discount}
              discountPrice={product.discountPrice}
              actualPrice={product.actualPrice}
            />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default BestSelling;
